import _ from 'lodash'

export const mapValues: MapValues = (obj, fn) => _.mapValues(obj, (value, id) => fn(value, id as any))
type MapValues = <TMap extends Record<string, any>, TValue, TTo = TMap[keyof TMap]>(
	obj: TMap,
	fn: (value: TTo, id: Exclude<keyof TMap, number>) => TValue
) => Record<string, TValue>
